import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Boxes",
description: "Overview of Freon’s predefined box types for building editor projections — including primitive, grouping, and external component boxes.",
tags: [ "boxes", "editor", "projections", "box types", "Svelte", "layout", "external components", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};